module.exports = __webpack_public_path__ + "img/sonora-forning-technologies.5a58740a.png";